module.exports = __webpack_public_path__ + "img/nav_study.54cb5bc3.svg";